import styled from 'styled-components'

export const CityAddEditWrapper = styled.div`
  position: relative;
  .section-wrapper {
    padding: 45px 40px 45px 40px;

    &:last-child {
      margin: 30px 0;
    }
    .section-label {
      margin: 0 0 10px 0;
      font-size: ${props => props.theme.fontSizes.city.addEdit};
    }
  }
  .city-details {
    div[class^='col-xs-3'] {
      margin: 25px 0;
    }
  }
  .pickup-times {
    div[class^='col-xs-3'] {
      margin: 10px 0;
    }
  }
  h2 {
    margin-bottom: 25px;
  }
  .section-label {
    color: ${props => props.theme.colors.secondary};
  }
`



// WEBPACK FOOTER //
// ./src/Components/City/CityAddEdit/Wrapper/index.js